import { EhrDetails } from "../../../../domain/ehr";

export type SharedState = {
  authToken?: string;
  baseUrl?: string;
  ehrDetails?: EhrDetails;
  isLoaded?: boolean;
  isMetriportUser?: boolean;
  isUserInSandbox?: boolean;
  userEmail?: string;
  isAmazonUser?: boolean;
  hasDashV2Access?: boolean;
};

export enum SharedStateActionType {
  set,
}

export type SharedStateAction = {
  type: SharedStateActionType.set;
  authToken: string;
  baseUrl: string;
  ehrDetails: EhrDetails | undefined;
  isMetriportUser: boolean;
  isUserInSandbox: boolean;
  userEmail?: string;
  isLoaded: boolean;
};

export const reducer = (state: SharedState, action: SharedStateAction) => {
  switch (action.type) {
    case SharedStateActionType.set: {
      const isAmazonUser =
        (action.userEmail?.endsWith("@amazon.com") ||
          action.userEmail?.endsWith("@onemedical.com") ||
          action.userEmail?.endsWith("+amazon@metriport.com")) ??
        false;

      const isOsmsUser =
        action.userEmail?.endsWith("@osmsgb.com") ||
        action.userEmail?.endsWith("+osmsgb@metriport.com");
      const isSeenUser =
        action.userEmail?.endsWith("@seenhealth.org") ||
        action.userEmail?.endsWith("+seenhealth@metriport.com");

      // Add additional CX checks here to provision DashV2 access
      const hasDashV2Access = isAmazonUser || isOsmsUser || isSeenUser || action.isMetriportUser;

      return {
        ...state,
        authToken: action.authToken,
        baseUrl: action.baseUrl,
        ehrDetails: action.ehrDetails,
        isLoaded: action.isLoaded,
        isMetriportUser: action.isMetriportUser,
        isUserInSandbox: action.isUserInSandbox,
        userEmail: action.userEmail,
        isAmazonUser,
        hasDashV2Access,
      };
    }

    default:
      return state;
  }
};

export const initialState: SharedState = {};
